<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          Resend Temporary Password
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <div class="text-body-1">
            Do you want to Resend a temporary password to
            <strong>{{ userEmail }}</strong>?
          </div>

          <div class="text-caption text-medium-emphasis mt-2">
            The user will receive a new temporary password via email.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

          <v-btn
            color="grey"
            variant="text"
            @click="handleClose"
            :disabled="loading"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            variant="flat"
            @click="handleResend"
            :loading="loading"
          >
            Resend
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();

import { resend_owner_invite } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "ResendInviteDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    userEmail() {
      return this.user?.user_email_id || "";
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },

    async handleResend() {
      if (!this.userEmail) return;

      this.loading = true;

      try {
        const response = await client.graphql({
          query: resend_owner_invite,
          variables: {
            input: {
              user_email_id: this.userEmail,
            },
          },
        });

        const responseData = JSON.parse(response.data.resend_owner_invite);

        if (responseData.status === "SUCCESS") {
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Temporary password sent successfully!",
            color: "success",
          };

          this.dialog = false;
        } else {
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Failed to resend password",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Resend error:", error);

        this.snackbar = {
          show: true,
          message:
            (error.errors && error.errors[0]?.message) ||
            error.message ||
            "Something went wrong",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>